import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedCreditCard = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="payment" size="100%" color={stroke ?? color} />
);

export { LineRoundedCreditCard };
